import { useContext, createContext } from 'react'
import * as Solver from '../Solver'
import { User } from '../Types'
import { ModuleProfile } from '../ModuleTypes'
import { getGuid } from '../Utils'
import { HubConnection } from '@microsoft/signalr'

export type ModuleState = {
  sessionGUID: string
  connection: HubConnection
  solverAvailable: boolean
  user: User
  userProfile: ModuleProfile
  groupName: string
  faultID: string
  hasError: boolean
  errorMessage: string
}

export const initialState: ModuleState = {
  sessionGUID: getGuid(),
  connection: Solver.setConnection(),
  solverAvailable: false,
  user: {} as User,
  userProfile: {} as ModuleProfile,
  groupName: '',
  faultID: 'F000',
  hasError: false,
  errorMessage: '',
}

const context = createContext<ModuleState>(initialState)

export const ModuleContext = context
export const ModuleContextProvider = context.Provider
export const ModuleContextConsumer = context.Consumer

export const useModuleContext = () => {
  const context = useContext(ModuleContext)
  if (!context) {
    throw new Error(
      'useModuleContext must be used within a ModuleContextProvider. Wrap a parent component in <ModuleContextProvider> to fix this error.'
    )
  }
  return context
}